export default __webpack_public_path__ + "static/media/LaluResume.f6385b0a.pdf";